import { SVGProps } from './types';

const PipeGreyIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1"
    height="24"
    fill="none"
    viewBox="0 0 1 24"
    {...props}
  >
    <path stroke="#D0D5DD" d="M.5 0v24"></path>
  </svg>
);

export { PipeGreyIcon };
